import { listOption } from '@/api/base/baseCargoClassify'
import optionsMixin from '../mixins/optionsMixin'

export default optionsMixin(listOption)
